import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import { REPORT_LANGUAGES } from '../../../Utils/ReportTranslation';

// Native names so each option is recognisable regardless of the UI language.
const LANGUAGE_NAMES = {
    he: 'עברית',
    en: 'English',
    ar: 'العربية',
    ru: 'Русский',
};

/**
 * Language selector shared by the HTML ledger reports (Trial Balance, P&L, Account Card).
 * The value is the report's own language and is independent of the application UI language.
 */
const ReportLanguageSelector = ({ reportLanguage, onReportLanguageChange, isTranslating = false }) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                backgroundColor: '#f8f9ff',
                borderRadius: '8px',
                border: '1px solid #e3e8ff',
                height: '36px',
            }}
        >
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>
                {t('ReportLanguage')}
            </span>
            <select
                value={reportLanguage}
                onChange={(event) => onReportLanguageChange(event.target.value)}
                disabled={isTranslating}
                title={t('TranslateReport')}
                style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#374151',
                    border: '1px solid #cbd5ff',
                    borderRadius: '6px',
                    padding: '3px 6px',
                    backgroundColor: '#ffffff',
                    cursor: isTranslating ? 'wait' : 'pointer',
                    outline: 'none',
                }}
            >
                {REPORT_LANGUAGES.map((code) => (
                    <option key={code} value={code}>
                        {LANGUAGE_NAMES[code]}
                    </option>
                ))}
            </select>
            {isTranslating && <CircularProgress size={14} />}
        </div>
    );
};

export default ReportLanguageSelector;
